export default ({ expirationWarning, description, details, note }) => `
    ${expirationWarning.length > 0 ? `<p class='expiration-warning'>${expirationWarning}</p>` : ''}
    ${description.length > 0 ? `<p class='description'>${description}</p>` : ''}
    ${details.map((detail) => `<p class='detail'>${detail}</p>`).join('')}
    ${note.length > 0 ? `<p class='note'>${note}</p>` : ''}
`;
